
export enum TableFilterEnum {
    search = 'search',
    limit = 'limit',
    page = 'page',
    order = 'order',
    orderBy = 'orderBy',
    _filter = '_filter'
}
